import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: '[appWhiteButton]',
    standalone: false
})
export class WhiteButtonDirective {
    @HostBinding('class') get classes(): string {
        return 'white-button-uniform';
    }
}
